import { IcrcLedgerCanister } from '@dfinity/ledger-icrc'
import { SignIdentity } from '@dfinity/agent'
import { ApproveParams } from '../../interfaces/walletActions'
import getAgent from '../../utils/getAgent'
import { Principal } from '@dfinity/principal'

interface ApproveTokenParams {
  approveParams: ApproveParams
  identity: SignIdentity
}

const approveToken = async ({
  identity,
  approveParams: {
    standard,
    tokenCanisterId,
    expiresAt,
    spender: { address, subaccount },
    amount,
  },
}: ApproveTokenParams) => {
  const agent = getAgent({ identity })

  switch (standard) {
    case 'ICP':
    case 'ICRC2':
    case 'ICRC3':
      if (!tokenCanisterId) {
        throw 'tokenCanisterId is missing'
      }

      const icrcLedger = IcrcLedgerCanister.create({
        agent,
        canisterId: Principal.fromText(tokenCanisterId),
      })

      const approveResponse = await icrcLedger.approve({
        amount: BigInt(amount),
        expires_at: expiresAt ? BigInt(expiresAt) : undefined,
        spender: {
          owner: Principal.fromText(address),
          subaccount: subaccount ? [subaccount] : [],
        },
      })

      return Number(approveResponse)
    default:
      throw 'Unsupported token'
  }
}

export default approveToken
